import { deletePhotos } from 'Services/Features/Treatment/Utils/treatmentUtils';
import Swal from 'sweetalert2';

export const handleDeletePhotos = async (dispatch, pivotId, setRefetch, setClickedIndex ) => {
    setClickedIndex(pivotId);
    try {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: "Anda tidak dapat mengembalikan data yang telah dihapus!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(deletePhotos({ pivotId }));
                setRefetch(prevRefetch => !prevRefetch);
                Swal.fire(
                    'Terhapus!',
                    'Banner telah dihapus.',
                    'success'
                )
                setClickedIndex(null);
            } else {
                setClickedIndex(null);
            } 
        })
    } catch (error) {
        setClickedIndex(null);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.message
        });
        console.error(error);
    }
}